
const currDomain = window.location.origin
export const postMessageScrollUp = ()=> window.top.postMessage("scrollUp", currDomain);
export const postMessageHeight = (elem)=>elem && window.top.postMessage((`height:${elem.clientHeight}`), currDomain);